import React, { memo, useCallback, useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Modal, Input, Radio, ScrollArea } from '@mantine/core'
import { RichTextEditor } from '@mantine/rte'
import { css } from '@emotion/css'
import { Button } from '@ow/comps'
import useAppListStore from './appListStore'
import { Tips } from './widget'
import { ModalStyle } from './styled/global'

const FormItem = ({ title, required = false, inline = false, children }) => {
  return (
    <div
      className={css`
        display: ${inline ? 'flex' : 'block'};
        align-items: center;
        margin-bottom: ${inline ? '0' : '12px'};
        gap: 12px;
      `}
    >
      <p
        className={css`
          line-height: 46px;
        `}
      >
        {required && <span className="text-red-500">* </span>}
        {title}：
      </p>
      {children}
    </div>
  )
}

const RadioLabelWithTips = ({ label, tips }) => {
  return (
    <div className="flex gap-2 items-center">
      <span>{label}</span>
      <Tips label={tips} />
    </div>
  )
}

const CreateModal = ({ opened, onClose, target }) => {
  const createApp = useAppListStore((state) => state.createApp)
  const { control, trigger, getValues, reset } = useForm()
  const [loading, setLoading] = useState(false)
  const submit = async () => {
    if (await trigger()) {
      const values = getValues()
      setLoading(true)
      if (await createApp(values)) {
        reset()
        onClose()
      }
      setLoading(false)
    }
  }

  const onCloseModal = useCallback(() => {
    reset()
    onClose()
  }, [onClose])

  return (
    <Modal
      opened={opened}
      onClose={onCloseModal}
      title="新建项目"
      size="76%"
      target={target}
      closeOnClickOutside={false}
      centered
    >
      <ModalStyle />
      <form>
        <FormItem title="项目名称" required>
          <Controller
            name="title"
            control={control}
            rules={{ required: true }}
            render={({ field, formState: { errors } }) => (
              <Input
                className={css`
                  width: 340px;
                `}
                placeholder="请输入项目名称"
                invalid={errors.title}
                {...field}
              />
            )}
          />
        </FormItem>
        <FormItem title="用户来源" inline>
          <Controller
            name="userSource"
            defaultValue="dygc"
            control={control}
            render={({ field }) => (
              <Radio.Group spacing="xl" {...field}>
                <Radio
                  value="dygc"
                  label={
                    <RadioLabelWithTips
                      label="调研工厂用户"
                      tips="添加用户时，可以从调研工厂注册用户和企业用户中添加，也可以新建用户，并且会同步到调研工厂企业中。"
                    />
                  }
                />
                <Radio
                  value="standalone"
                  label={
                    <RadioLabelWithTips
                      label="独立用户"
                      tips="用户体系独立运行，与调研工厂等用户源没有关联。"
                    />
                  }
                />
              </Radio.Group>
            )}
          />
        </FormItem>
        <FormItem title="项目说明">
          <ScrollArea
            className={css`
              height: 340px;
            `}
          >
            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <RichTextEditor
                  className={css`
                    min-height: 340px;
                  `}
                  {...field}
                />
              )}
            />
          </ScrollArea>
        </FormItem>
        <div className="flex justify-end gap-4">
          <Button type="primary" onClick={submit} loading={loading}>
            下一步
          </Button>
          <Button stroke onClick={onClose}>
            返 回
          </Button>
        </div>
      </form>
    </Modal>
  )
}

export default memo(CreateModal)
